<template>
  <div class="home">
    <h1 style="position: absolute; top: -200px">
      Start Your Dropshipping Business with ANTDIY
    </h1>
    <!-- <Header name="Home"></Header> -->
    <div class="home_banner_wrapper">
      <div
        class="home_banner_notransition"
        :style="{ transform: `translateX(${-bannerIndex * 100 + '%'})` }"
      >
        <TopHP
          class="home_banner_part"
          title="End-to-end e-commerce dropshipping solutions for small & medium sellers"
          subtitle="Make your e-commerce business more agile and efficient"
          content="Import high-quality products from AliExpress in one-click and add them to your Shopify store. Automate order placement and logistics tracking. Design and promote your store with our marketing tools."
          btn="Start your dropshipping business now"
          img="/static/imgs/home.svg"
          bg="top_bg_h"
        ></TopHP>
        <TopHP
          class="home_banner_part"
          title="ANTDIY Pro:"
          wrap="The Change-Oriented ERP for online business, Proactive and Intelligent"
          subtitle="A Sustainable/Repeatable Profit Generation Workflow"
          :content="frontList"
          btn="Get Started"
          img="/static/imgs/antsupply_top.svg"
          bg="top_bg_p_pro"
          tlcontent="top_left_content_pro_h"
          tlsymbol="top_left_symbol_pro_h"
          tlcontent1="top_left_content_1_pro"
        ></TopHP>
        <TopHP
          class="home_banner_part"
          title="End-to-end e-commerce dropshipping solutions for small & medium sellers"
          subtitle="Make your e-commerce business more agile and efficient"
          content="Import high-quality products from AliExpress in one-click and add them to your Shopify store. Automate order placement and logistics tracking. Design and promote your store with our marketing tools."
          btn="Start your dropshipping business now"
          img="/static/imgs/home.svg"
          bg="top_bg_h"
        ></TopHP>
      </div>
      <div class="banner_footer">
        <span
          class="circle"
          :class="bannerIndex !== 1 ? 'circle_active circle' : 'circle'"
          @click="changeBannerNum(0)"
        ></span>
        <span
          class="circle"
          :class="bannerIndex === 1 ? 'circle_active circle' : 'circle'"
          @click="changeBannerNum(1)"
        ></span>
      </div>
    </div>
    <div class="home_display">
      <div class="home_display_box">
        <h2 class="home_display_title">Expert Services From ANTDIY Team</h2>
        <div class="home_display_content">
          <div
            class="home_say_left home_say_click"
            @click="clickLeft2"
            @mouseover="slideOver2"
            @mouseout="slideOut2"
          >
            <img src="../assets/arrow_left.svg" alt="" />
          </div>
          <div class="home_display_content_box">
            <div
              id="slide"
              class="home_display_content_item"
              v-for="(item, index) in displayList"
              :key="index"
              :style="{
                transform: `translateX(${-displayIndex * 1220 + 'px'})`,
              }"
              @mouseover="slideOver2"
              @mouseout="slideOut2"
            >
              <img :src="item.image" :alt="item.title" />
              <div class="home_display_content_item_content">
                <h3>{{ item.title }}</h3>
                <a
                  :href="item.href"
                  target="_blank"
                  v-if="isMobileHome == false"
                  ><div>LEARN MORE</div></a
                >
                <a @click="goservice(item.name)" v-else
                  ><div>LEARN MORE</div></a
                >
              </div>
            </div>
          </div>
          <div
            class="home_say_right home_say_click"
            @click="clickRight2"
            @mouseover="slideOver2"
            @mouseout="slideOut2"
          >
            <img src="../assets/arrow_right.svg" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="home_what">
      <div class="home_what_box">
        <h2 class="home_title">What is ANTDIY?</h2>
        <div class="home_what_line">
          <div class="home_what_line_text">
            <div class="title_icon home_what_line_text_symbol"></div>
            <div>
              <h3 class="home_what_line_text_title">
                ANTDIY is Dropshipping App of AliExpress Official Partner
              </h3>
            </div>
            <div class="home_what_line_text_content">
              It allows you to find all kinds of products to sell online, add
              them to your Shopifty store, and start selling now. Never worry
              about packaging or shipping, and focus on developing your
              business.
            </div>
          </div>
          <div class="home_what_line_img">
            <img
              src="static/imgs/land4.png"
              alt="ANTDIY is Dropshipping App of AliExpress Official Partner"
              title="ANTDIY is Dropshipping App of AliExpress Official Partner"
            />
          </div>
        </div>
        <div class="home_what_line home_what_line2">
          <div class="home_what_line_img">
            <img
              src="static/imgs/land5.png"
              alt="Directly Connected to the AliExpress Platform"
              title="Directly Connected to the AliExpress Platform"
            />
          </div>
          <div class="home_what_line_text">
            <div class="title_icon home_what_line_text_symbol"></div>
            <div>
              <h3 class="home_what_line_text_title">
                Directly Connected to the AliExpress Platform
              </h3>
            </div>
            <div class="home_what_line_text_content">
              We provide you with access to billions of products.Our supply
              chain innovations enable us to offer you good prices by connecting
              you with suppliers from AliExpress.
            </div>
          </div>
        </div>
        <div class="home_what_line">
          <div class="home_what_line_text">
            <div class="title_icon home_what_line_text_symbol"></div>
            <div>
              <h3 class="home_what_line_text_title">
                ANTDIY: AliExpress Dropshipping Ecommerce Plugins for Online
                Stores!
              </h3>
            </div>
            <div class="home_what_line_text_content">
              ANTDIY provides dropshippers with a one-stop solution to purchase
              cross-border products as simply and reliably as they do from local
              quality suppliers.
            </div>
          </div>
          <div class="home_what_line_img">
            <img
              src="static/imgs/land6.png"
              alt="ANTDIY: AliExpress Dropshipping Ecommerce Plugins for Online Stores!"
              title="ANTDIY: AliExpress Dropshipping Ecommerce Plugins for Online Stores!"
            />
          </div>
        </div>
        <div class="home_what_bottom">
          <h2 class="home_what_bottom_title1">ANTDIY supported platforms</h2>
          <div class="home_what_bottom_platform">
            <div class="home_what_bottom_img1">
              <img
                src="../assets/land30.svg"
                class="home_what_bottom_img1_img1"
                alt="Shopify"
                @click="
                  goLink(
                    `https://platform.antdiy.vip/#/register?source=${source}`
                  )
                "
              />
            </div>
            <div class="home_what_bottom_img1">
              <img
                src="../assets/land31.svg"
                class="home_what_bottom_img1_img2"
                alt="BigCommerce"
                @click="
                  goLink(
                    `https://platform.antdiy.vip/#/register?source=${source}`
                  )
                "
              />
            </div>
            <div class="home_what_bottom_img2">
              <img
                src="../assets/land33.svg"
                class="home_what_bottom_img2_img2"
                alt="WooCommerce"
                @click="
                  goLink(
                    `https://platform.antdiy.vip/#/register?source=${source}`
                  )
                "
              />
            </div>
            <div class="home_what_bottom_img2">
              <img
                src="../assets/land32.svg"
                class="home_what_bottom_img2_img1"
                alt="Wix"
                @click="
                  goLink(
                    `https://platform.antdiy.vip/#/register?source=${source}`
                  )
                "
              />
            </div>
          </div>
          <div class="home_what_bottom_platform2">
            <div class="home_what_bottom_img2">
              <img
                src="../assets/land35.svg"
                class="home_what_bottom_img2_img1"
                alt="square"
                @click="
                  goLink(
                    `https://platform.antdiy.vip/#/register?source=${source}`
                  )
                "
              />
            </div>
          </div>
          <div class="home_what_bottom_title2">More platforms coming soon</div>
        </div>
      </div>
    </div>
    <div class="home_why_head">
      <div class="home_why">
        <h2 class="home_title">Why ANTDIY?</h2>
        <div class="home_why_box">
          <div class="home_why_column">
            <img src="/static/imgs/home_way1.png" />
            <h3 class="home_why_column_title">Dropshipping Made Easy</h3>
            <div class="home_why_column_content">
              ANTDIY is an exclusive AliExpress API and Official Partner,
              directly connected to the Alibaba platform. Our app simplifies
              your entire dropshipping process.
            </div>
          </div>
          <div class="home_why_column">
            <img src="/static/imgs/home_way2.png" />
            <h3 class="home_why_column_title">
              Billions of Products to Choose From
            </h3>
            <div class="home_why_column_content">
              Source your assortment from a wide variety of reliable suppliers.
            </div>
          </div>
          <div class="home_why_column">
            <img src="/static/imgs/home_way3.png" />
            <h3 class="home_why_column_title">Worry-Free Delivery</h3>
            <div class="home_why_column_content">
              Stop worrying about shipping. Once you make a sale, your products
              will be shipped from the supplier warehouse to your customer’s
              doorstep.
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="home_say">
      <div class="home_say_box">
        <h2 class="home_say_title">What do our customers say?</h2>
        <DisPlay
          :sayList="sayList"
          name=".home_say_box"
          cater="1"
          count="2"
        ></DisPlay>
      </div>
    </div>
    <div class="home_Partnership_background">
      <div class="home_Partnership">
        <h2 class="home_title">Partnership</h2>
        <div class="home_Partnership_imgs">
          <img
            src="/static/imgs/alipreess2.png"
            @click="goLink('https://www.aliexpress.com/')"
          />
          <img
            src="/static/imgs/shopify2.png"
            @click="goLink('https://www.shopify.com/')"
          />
          <img
            src="/static/imgs/Google2.png"
            @click="goLink('https://www.google.com/')"
          />
          <img
            src="/static/imgs/facebook2.png"
            @click="goLink('https://www.facebook.com/')"
          />
        </div>
      </div>
    </div>
    <div class="home_cover" v-if="homeorder">
      <div class="home_position">
        <div class="home_box">
          <img
            src="/static/imgs/consult_close.svg"
            alt="close"
            class="home_box_close"
            @click="homeorder = false"
          />
          <div class="home_box_main" v-if="showsecond">
            <div class="home_box_content">
              <h1>Get E-commerce Marketing Research Report 2024</h1>
              <h2>
                Overall market trends,popular market analysis, marking promotion
                analysis, industry perspectives.
              </h2>
              <input
                type="text"
                placeholder="email@website.com"
                class="home_box_content_text"
                v-model="mail"
                @input="checkmail"
              />
              <div class="homex_box_content_showfalse" v-if="showfalse">
                Please enter correct email
              </div>
              <label
                ><input
                  type="checkbox"
                  class="home_box_content_check"
                  v-model="ischeckd"
                />I agree to receive communications from ANTDIY. I can
                unsubscribe at any time.</label
              >
              <div class="home_box_content_download" @click="submit">
                {{ download }}
              </div>
            </div>
            <img
              src="../assets/home_book.png"
              alt="Get E-commerce Marketing Research Report 2024"
              class="home_box_img"
            />
          </div>
          <div class="home_box_main2" v-else>
            <img
              src="../assets/home_second.svg"
              alt="The report has been sent to your email, Please check it!"
            />
            <h2>The report has been sent to your email, Please check it!</h2>
            <div class="home_box_main2_button" @click="homeorder = false">
              Back to Home
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer :isIp="isIp"></Footer>
  </div>
</template>

<script>
import Header from "./common/header.vue";
import Footer from "./common/footer.vue";
import TopHP from "./common/topHP.vue";
import DisPlay from "./common/display.vue";

export default {
  name: "Home",
  components: {
    Header,
    Footer,
    TopHP,
    DisPlay,
  },
  data() {
    return {
      sayList: [
        {
          icon: "/static/imgs/portrait1.png",
          name: "Ga**ett",
          country: "US",
          content:
            "“I am the owner of a dedicated e-platform. The one-stop supply chain solution from Antdiy enables hassle-free integration with various modules including Product, Order, Parcel and Logistics through the Open API, which frees us from the burden of dealing with multiple service providers. Plus, it helps us greatly diversify our product offerings, and now Chinese products are seeing a 55% increase in sales.”",
        },
        {
          icon: "/static/imgs/portrait2.png",
          name: "Sn**ky",
          country: "South Africa",
          content:
            "“Love Antdiy. They make it so easy to set it up a store with products. Especially bulk order function, you can save a lot of time and be accurate at the same time when you have more than 100 orders. this is where Antdiy really shines. thank you！”",
        },
        {
          icon: "/static/imgs/portrait3.png",
          name: "Hom***ario",
          country: "US",
          content: `“I used the ANTDIY app to increase the product selection in my online store. It did not disappoint！ ANTDIY currently assisted me to enhance the sales. I used the app it's great i recomend 100% more than 1000 sells in one hour the best, for beginers and it's free.”`,
        },
        {
          icon: "/static/imgs/portrait4.png",
          name: "Da**in",
          country: "Canada",
          content: `“It's a very useful application for dropshipping automation, it's easy and also simple to use user interface with one-click import products. I use it as a begginer, find specific items within a certain niche. The info gathered and sorted saves me much time and effort！ This has actually made my life so much less complicated！！！！”`,
        },
        {
          icon: "/static/imgs/portrait5.png",
          name: "De**nt",
          country: "US",
          content: `“Thank ANTDIY！ Looks and works great！ Huge upgrade over our products and orders, Fulfil bulk orders with one click！ A "must have' one, especially for drop shipping！！ I can't also envision doing this without it now.”`,
        },
        {
          icon: "/static/imgs/portrait6.png",
          name: "Ki**n",
          country: "US",
          content:
            "“Very well worth and easy to use, it is fast and efficient. They have good customer service, terrific client assistance answer with in less than a minute.”",
        },
        {
          icon: "/static/imgs/portrait7.png",
          name: "Sa**y",
          country: "Canada",
          content: `“I get notices regarding AliExpress products that are out of supply as well as my shop is updated instantly so that my clients  aren't buying something I can not fufill. Integrated tracking for orders, and also a support team that is really responsive as well as very useful step by step direction when required！”`,
        },
        {
          icon: "/static/imgs/portrait8.png",
          name: "Sh**im",
          country: "Canada",
          content:
            '“ANTDIY is simply the most effective Dropshipping App on the marketplace. Highly recommended！ “fully computerized"... “time conserving"...“free e-commerce education and learning."',
        },
        {
          icon: "/static/imgs/portrait9.png",
          name: "Mo**ca",
          country: "US",
          content: `“ANTDIY saves me a lot time in regards to adding items, editing photos as well as mapping the versions. I would love to have the alternative of uploading photos or editing and enhancing images through ANTDIY. I'm really amazed！ It is a terrific application ever before ^ ^ It's truly practical for me ！！ Thanks ANTDIY^ ^ You are the best."`,
        },
      ],
      displayList: [
        {
          image: "../../static/imgs/home-service1.png",
          title: "Products Sourcing",
          href: "https://www.antdiy.vip/services#Products%20Sourcing",
          name: "Products_Sourcing",
        },
        {
          image: "../../static/imgs/home-service2.png",
          title: "Products Procurement",
          href: "https://www.antdiy.vip/services#Products%20Procurement",
          name: "Products_Procurement",
        },
        {
          image: "../../static/imgs/home-service3.png",
          title: "Personalized Products Selection",
          href: "https://www.antdiy.vip/services#Personalized%20Products%20Selection",
          name: "Personalized_Products_Selection",
        },
        {
          image: "../../static/imgs/home-service4.png",
          title: "Supplier Verification",
          href: "https://www.antdiy.vip/services#Supplier%20Verification",
          name: "Supplier_Verification",
        },
        {
          image: "../../static/imgs/home-service5.png",
          title: "Logistics Service",
          href: "https://www.antdiy.vip/services#Logistics%20service",
          name: "Logistics_service",
        },
        {
          image: "../../static/imgs/home-service6.png",
          title: "Warehouse Service",
          href: "https://www.antdiy.vip/services#Warehouse%20service",
          name: "Warehouse_service",
        },
        {
          image: "../../static/imgs/home-service7.png",
          title: "All-in-one Supply Chain Services",
          href: "https://www.antdiy.vip/services#All-in-one%20Supply%20Chain%20Services",
          name: "All-in-one_Supply_Chain_Services",
        },
        {
          image: "../../static/imgs/home-service8.png",
          title: "Banner Ads Design",
          href: "https://www.antdiy.vip/services#Banner%20Ads%20Design",
          name: "Banner_Ads_Design",
        },
        {
          image: "../../static/imgs/home-service9.png",
          title: "Holiday Promotion Bundle",
          href: "https://www.antdiy.vip/services#Holiday%20Promotion%20Bundle",
          name: "Holiday_Promotion_Bundle",
        },
        {
          image: "../../static/imgs/home-service10.png",
          title: "Advertising Service",
          href: "https://www.antdiy.vip/services#Advertising%20service",
          name: "Advertising_service",
        },
        {
          image: "../../static/imgs/home-service11.png",
          title: "Facebook Ads Consulting & Diagnosis",
          href: "https://www.antdiy.vip/services#Facebook%20Ads%20Consulting%20&%20Diagnosis",
          name: "Facebook_Ads_Consulting_Diagnosis",
        },
        {
          image: "../../static/imgs/home-service12.png",
          title: "Expert Team Service",
          href: "https://www.antdiy.vip/services#Expert%20team%20service",
          name: "Expert_team_service",
        },
      ],
      sayIndex: 0,
      // trNum: 610
      handleScrollFlag: true,
      screenWidth: window.innerWidth,
      isMobileHome: false,
      RollPointActive: 1,
      time2: undefined,
      changeSayTimer2: undefined,
      isIp: false,
      displayIndex: 0,
      serviceScrollFlag: true,
      serviceshow: undefined,
      homeorder: "",
      mail: "",
      showfalse: false,
      ischeckd: true,
      showsecond: true,
      type: "",
      download: "Download Now",
      isclick: true,
      bannerIndex: 0,
      frontList: [
        {
          msg: "Scaling business on multichannel with smart Integration",
        },
        {
          msg: "Putting up profitable product portfolio with AI",
        },
        {
          msg: "Maximizing supply chain flexibility with automated order fulfillment process",
        },
      ],
      bannerShow: undefined,
      changeBanner: undefined,
      inputData: "",
      source: localStorage.getItem("ant_source") || "",
    };
  },
  methods: {
    enlargeSayList() {
      if (this.screenWidth > 767) {
        this.displayList.unshift(this.displayList[this.displayList.length - 1]);
        this.displayList.unshift(this.displayList[this.displayList.length - 2]);
        this.displayList.unshift(this.displayList[this.displayList.length - 3]);
        this.displayList.unshift(this.displayList[this.displayList.length - 4]);
        this.displayList.push(this.displayList[4]);
        this.displayList.push(this.displayList[5]);
        this.displayList.push(this.displayList[6]);
        this.displayList.push(this.displayList[7]);
        this.displayIndex = 1;
      }
    },
    clickLeft2() {
      // console.log(this.displayIndex)
      let date = new Date().getTime();
      if (!this.time2 || this.time2 < date - 500) {
        this.time2 = date;
        if (this.displayIndex == 0) {
          for (let i = 0; i < this.displayList.length; i++) {
            document.querySelector(".home_display_content_item").className =
              "home_display_content_item_notransition";
          }
          this.displayIndex = Math.floor(this.displayList.length / 4) - 2;
          // this.changeSayTimer2 = setTimeout(this.changeSeamless2, 500)
        } else {
          this.displayIndex--;
        }
      }
    },
    clickRight2() {
      // console.log(this.displayIndex)
      let date = new Date().getTime();
      if (!this.time2 || this.time2 < date - 500) {
        this.time2 = date;
        if (Math.floor(this.displayList.length / 4 - 2) == this.displayIndex) {
          for (let i = 0; i < this.displayList.length; i++) {
            document.querySelector(".home_display_content_item").className =
              "home_display_content_item_notransition";
          }
          this.displayIndex = 0;
          // this.changeSayTimer2 = setTimeout(this.changeSeamless2, 500)
        } else {
          this.displayIndex++;
        }
      }
    },
    goservice(index) {
      let winref = window.open("url", "_blank");
      winref.location = "/services#" + index;
    },
    changeSeamless2() {
      clearTimeout(this.changeSayTimer2);
      if (this.displayIndex == 0) {
        for (let i = 0; i < this.displayList.length; i++) {
          document.querySelector(
            ".home_display_content_item_notransition"
          ).className = "home_display_content_item";
        }
        this.displayIndex++;
      } else {
        for (let i = 0; i < this.displayList.length; i++) {
          document.querySelector(
            ".home_display_content_item_notransition"
          ).className = "home_display_content_item";
        }
        this.displayIndex--;
      }
    },
    goLink(url) {
      window.open(url);
    },
    submit() {
      this.checkmail();
      this.ischeckd === true ? (this.type = 1) : (this.type = 0);
      if (
        this.showfalse === false &&
        this.mail !== "" &&
        this.isclick === true
      ) {
        this.isclick = false;
        this.download = "Sending...";
        setTimeout(() => {
          this.showsecond = false;
        }, 1000);
        this.$axios
          .get(
            `https://gateway.antdiy.vip/account-service/email/send_file?email=${this.mail}&type=${this.type}`
          )
          .then((res) => {
            if (res.data.success) {
              localStorage.setItem("order", 1);
            } else {
              this.isclick === true;
            }
          });
      }
    },
    checkmail() {
      let reg = new RegExp(
        "^[a-z0-9A-Z]+[- | a-z0-9A-Z . _]+@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?\\.)+[a-z]{2,}$"
      );
      if (!reg.test(this.mail)) {
        this.showfalse = true;
      } else {
        this.showfalse = false;
      }
    },
    keyRollChange() {
      let keyLine = document.querySelector(".home_key_line");
      let id =
        (keyLine.scrollLeft / (keyLine.scrollWidth - keyLine.clientWidth)) * 9;
      if (id > 9) {
        id = 9;
      }
      this.RollPointActive = id == 0 ? 1 : Math.ceil(id);
    },
    slideOver2() {
      if (this.screenWidth > 767) {
        clearInterval(this.serviceshow);
      }
    },
    slideOut2() {
      if (this.screenWidth > 767) {
        // this.clickRight()
        // this.serviceshow = setInterval(this.clickRight2, 4000);
      }
    },
    keyRoll() {
      window.addEventListener("scroll", this.keyRollChange, true);
    },
    bannerTranslate() {
      this.bannerIndex += 1;
      if (this.bannerIndex === 1) {
        if (document.querySelector(".home_banner_notransition")) {
          document.querySelector(".home_banner_notransition").className =
            "home_banner";
        }
      }
      if (this.bannerIndex === 2) {
        this.changeBanner = setTimeout(this.bannerBack, 2000);
      }
    },
    bannerBack() {
      clearTimeout(this.changeBanner);
      this.bannerIndex = 0;
      if (document.querySelector(".home_banner")) {
        document.querySelector(".home_banner").className =
          "home_banner_notransition";
      }
    },
    changeBannerNum(num) {
      clearInterval(this.bannerShow);
      this.bannerIndex = num;
      if (document.querySelector(".home_banner_notransition")) {
        document.querySelector(".home_banner_notransition").className =
          "home_banner";
      }
      if (this.screenWidth > 767) {
        this.bannerShow = setInterval(this.bannerTranslate, 6000);
      }
    },
  },
  created() {
    this.enlargeSayList();
    if (localStorage.getItem("order") != "1") {
      setTimeout(() => {
        this.homeorder = true;
      }, 3000);
    }
    if (document.body.offsetWidth > 767) {
      this.isMobileHome = false;
    } else {
      this.isMobileHome = true;
    }
  },
  mounted() {
    if (this.isMobileHome) {
      // this.keyRoll();
    } else {
      // this.tabScroll();
      if (this.screenWidth > 767) {
        //  this.serviceshow = setInterval(this.clickRight2, 4000);
        this.bannerShow = setInterval(this.bannerTranslate, 6000);
      }
    }
  },
  deactivated() {
    if (this.isMobileHome) {
      // window.removeEventListener('scroll', this.keyRollChange, true)
    } else {
      // window.removeEventListener('scroll', this.handleScrollHome)
      if (this.serviceshow) {
        window.clearInterval(this.serviceshow);
      }
    }
  },
};
</script>

<style scoped>
.home {
  overflow: hidden;
}
.home_banner_wrapper {
  position: relative;
}
.home_banner {
  display: flex;
  transition: all 1.5s;
}
.home_banner_notransition {
  display: flex;
  transition: none;
}
.home_banner_part {
  flex: none;
}
.banner_footer {
  position: absolute;
  bottom: 11px;
  width: 46px;
  left: 50%;
  margin-left: -23px;
}
.banner_footer > .circle {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #aeb8d6;
  opacity: 0.35;
  cursor: pointer;
}
.banner_footer > .circle:last-child {
  margin-left: 5px;
}
.banner_footer > .circle_active {
  background: #aeb8d6;
  opacity: 1;
}
.home_cover {
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
}
.home_position {
  width: 890px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.home_box {
  width: 100%;
  background: url("/static/imgs/home_back.png") no-repeat;
  background-size: cover;
  animation: mymove 0.4s;
  padding: 98px 45px 87px;
  border-radius: 10px;
  background-color: #6597ff;
  background-position: center;
}
.home_box_main {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.home_box_main2 {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.home_box_main2 img {
  width: 274px;
  height: 284px;
}
.home_box_main2 h2 {
  font-family: Helvetica;
  font-size: 24px;
  color: #ffffff;
  letter-spacing: 0;
  line-height: 24px;
  font-weight: 400;
  margin-bottom: 55px;
  margin-top: 20px;
}
.home_box_main2_button {
  width: 448px;
  height: 64px;
  background: #1f00be;
  box-shadow: 0px 6px 8px 0px rgba(5, 0, 105, 0.24);
  border-radius: 8px;
  font-family: Helvetica-Bold;
  font-size: 24px;
  color: #ffffff;
  font-weight: 700;
  line-height: 64px;
  text-align: center;
  cursor: pointer;
}
.home_box_close {
  position: absolute;
  right: 45px;
  top: 39px;
  width: 40px;
  height: 40px;
  cursor: pointer;
}
.home_box_img {
  width: 287px;
  height: 378px;
}
.home_box_content {
  display: flex;
  flex-direction: column;
  width: 448px;
}
.home_box_content h1 {
  font-family: Helvetica-Bold;
  font-size: 34px;
  color: #ffffff;
  letter-spacing: -0.2px;
  line-height: 32px;
  font-weight: 700;
}
.home_box_content h2 {
  font-family: Helvetica;
  font-size: 20px;
  color: #ffffff;
  letter-spacing: 0;
  line-height: 24px;
  font-weight: 400;
  margin: 23px auto 35px;
}
.home_box_content_text {
  width: 100%;
  height: 56px;
  background: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 8px;
  font-family: Helvetica;
  font-size: 20px;
  color: #000000;
  font-weight: 400;
  text-align: center;
}
.home_box_content_text::-webkit-input-placeholder {
  color: rgba(0, 0, 0, 0.3);
}
.home_box_content_text::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: rgba(0, 0, 0, 0.3);
}
.home_box_content_text:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: rgba(0, 0, 0, 0.3);
}
.home_box_content_text:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: rgba(0, 0, 0, 0.3);
}
.home_box_content_text:hover {
  border: 2px solid rgba(255, 99, 0, 1);
}
.homex_box_content_showfalse {
  font-size: 14px;
  color: #ff8453;
  margin-top: 5px;
}
.home_box_content label {
  font-family: Helvetica;
  font-size: 18px;
  color: #ffffff;
  letter-spacing: 0;
  line-height: 20px;
  font-weight: 400;
  margin: 12px auto 38px;
  display: flex;
  align-items: flex-start;
}
.home_box_content_check {
  margin-right: 14px;
  margin-top: 3px;
}
.home_box_content_download {
  width: 100%;
  height: 64px;
  background: #1f00be;
  box-shadow: 0px 6px 8px 0px rgba(5, 0, 105, 0.24);
  border-radius: 8px;
  line-height: 64px;
  text-align: center;
  font-family: Helvetica-Bold;
  font-size: 24px;
  color: #ffffff;
  font-weight: 700;
  cursor: pointer;
}
.home_title {
  padding: 81px 0 40px;
  font-size: 32px;
  font-family: Helvetica-Bold, Helvetica;
  font-weight: bold;
  color: #222536;
  line-height: 40px;
  text-align: center;
}
.home_display {
  padding: 80px 0;
  background: #f6f7fa;
}
.home_display_title {
  font-family: Helvetica-Bold;
  font-size: 32px;
  color: #222536;
  letter-spacing: 0;
  line-height: 40px;
  font-weight: 700;
  margin-bottom: 53px;
  text-align: center;
}
.home_display_box {
  width: 1200px;
  margin: auto;
}
.home_display_content {
  position: relative;
}
.home_display_content_item {
  width: 285px;
  height: 355px;
  background: #ffffff;
  box-shadow: 0px 8px 18px 0px rgba(139, 145, 160, 0.1);
  border-radius: 8px;
  transition: all 1.5s;
}
.home_display_content_item + .home_display_content_item {
  margin-left: 20px;
}
.home_display_content_item_notransition
  + .home_display_content_item_notransition {
  margin-left: 20px;
}
.home_display_content_item_notransition {
  width: 285px;
  height: 355px;
  background: #ffffff;
  box-shadow: 0px 8px 18px 0px rgba(139, 145, 160, 0.1);
  border-radius: 8px;
}
.home_display_content_item_notransition img {
  width: 100%;
  border-radius: 8px;
  height: 160px;
}
.home_display_content_item img {
  width: 100%;
  border-radius: 8px 8px 0 0;
  height: 160px;
}
.home_display_content_box {
  display: flex;
  overflow: hidden;
}
.home_display_content_item_content {
  padding: 20px;
  display: flex;
  flex-direction: column;
  height: 195px;
  justify-content: space-between;
}
.home_display_content_item_content h3 {
  font-family: Helvetica-Bold;
  font-size: 24px;
  color: #222536;
  letter-spacing: 0;
  font-weight: 700;
  display: flex;
  justify-content: flex-start;
}
.home_display_content_item_content div {
  width: 245px;
  height: 48px;
  background: #ffffff;
  border: 2px solid #fb5421;
  border-radius: 4px;
  font-family: Helvetica-Bold;
  font-size: 14px;
  color: #fb5421;
  letter-spacing: 0;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.home_what {
  background: #ffffff;
}
.home_what_box {
  width: 1200px;
  margin: 0 auto;
}
.home_what_line {
  display: flex;
  justify-content: space-between;
  height: auto;
  padding-bottom: 80px;
  overflow: hidden;
}
.home_what_line_text {
  width: 580px;
}
.home_what_line_text_symbol {
  margin: 66px 0 21px;
}
.home_what_line_text_title {
  font-size: 24px;
  font-family: Helvetica-Bold, Helvetica;
  font-weight: bold;
  color: #222536;
  line-height: 28px;
  margin-bottom: 20px;
}
.home_what_line_text_content {
  font-size: 20px;
  font-family: Helvetica;
  color: #8d919b;
  line-height: 24px;
}
.home_what_line_img {
  width: 492px;
  background: rgba(252, 83, 34, 0.12);
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  padding: 21px;
}
.home_what_line_img img {
  width: 100%;
}
.home_what_line_text + .home_what_line_img,
.home_what_line_img + .home_what_line_text {
  margin-left: 130px;
}
.home_what_bottom {
  padding: 40px 0 100px 0;
}
.home_what_bottom_title1 {
  font-size: 32px;
  font-family: Helvetica-Bold, Helvetica;
  font-weight: bold;
  color: #222536;
  line-height: 40px;
  text-align: center;
}
.home_what_bottom_title2 {
  font-size: 24px;
  font-family: Helvetica;
  color: #8d919b;
  line-height: 29px;
  text-align: center;
}
.home_what_bottom_platform {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 48px 0 0 0;
}
.home_what_bottom_platform2 {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 23px 0 36px 0;
}
.home_what_bottom_img1 {
  width: 283px;
  height: 136px;
  background: #ffffff;
  border-radius: 8px;
  text-align: center;
  line-height: 136px;
  box-shadow: 0px 2px 18px 0px rgba(139, 145, 160, 0.15);
  cursor: pointer;
}
.home_what_bottom_img1_img1 {
  width: 159px;
  height: 56px;
}
.home_what_bottom_img1_img2 {
  width: 200px;
  height: 45px;
}
.home_what_bottom_img2 {
  width: 283px;
  height: 136px;
  background: #ffffff;
  border-radius: 8px;
  text-align: center;
  line-height: 136px;
  position: relative;
  box-shadow: 0px 2px 18px 0px rgba(139, 145, 160, 0.15);
  cursor: pointer;
}
.home_what_bottom_img2_img1 {
  width: 150px;
  height: 51px;
}
.home_what_bottom_img2_img2 {
  width: 200px;
  height: 41px;
}

.home_why_head {
  background: #f6f7fa;
}
.home_why {
  width: 1200px;
  margin: 0 auto;
}
.home_why_box {
  display: flex;
  justify-content: space-between;
}
.home_why_column {
  width: 387px;
}
.home_why_column img {
  width: 387px;
}
.home_why_column_title {
  font-size: 20px;
  font-family: Helvetica-Bold, Helvetica;
  font-weight: bold;
  color: #222536;
  line-height: 28px;
  margin: 26px 0 12px;
}
.home_why_column_content {
  font-size: 16px;
  font-family: Helvetica;
  color: #8d919b;
  line-height: 24px;
  padding-bottom: 80px;
}

.home_say {
  padding: 80px 0 60px;
  background: #ffffff;
}
.home_say_box {
  width: 1220px;
  margin: 0 auto;
}
.home_say_title {
  font-size: 32px;
  font-family: Helvetica-Bold, Helvetica;
  font-weight: bold;
  color: #222536;
  line-height: 40px;
  margin-bottom: 21px;
  text-align: center;
}
.home_say_content {
  position: relative;
}
.home_say_content_line {
  display: flex;
  overflow: hidden;
  justify-content: space-between;
  padding: 18px 0 18px 0;
}
.home_say_left,
.home_say_right {
  width: 48px;
  height: 48px;
  background: #fff;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  cursor: not-allowed;
}
.home_say_left {
  left: -58px;
}
.home_say_right {
  right: -58px;
}
.home_say_click:hover {
  background: #c9cdd7;
  cursor: pointer;
}
.home_say_content_item {
  flex: none;
  width: 590px;
  background: #fff;
  padding: 40px 40px 40px 32px;
  box-shadow: 0px 8px 18px 0px rgba(139, 145, 160, 0.15);
  border-radius: 8px;
  transition: all 0.8s;
}
.home_say_content_item + .home_say_content_item {
  margin-left: 20px;
}
.home_say_content_item_no_transition {
  flex: none;
  width: 590px;
  background: #fff;
  padding: 40px 40px 40px 32px;
  box-shadow: 0px 8px 18px 0px rgba(139, 145, 160, 0.15);
  border-radius: 8px;
}
.home_say_content_item_no_transition + .home_say_content_item_no_transition {
  margin-left: 20px;
}
.home_say_content_top {
  display: flex;
  align-items: center;
}
.home_say_content_top img {
  width: 48px;
  height: 48px;
}
.home_say_content_top em {
  width: 1px;
  height: 16px;
  background: #8d919b;
}
.home_say_content_top_name {
  font-size: 20px;
  font-family: Helvetica-Bold, Helvetica;
  font-weight: bold;
  color: #222536;
  line-height: 28px;
  margin: 0 15px 0 28px;
}
.home_say_content_top_country {
  font-size: 16px;
  font-family: Helvetica;
  color: #8d919b;
  line-height: 28px;
  margin-left: 20px;
}
.home_say_content_text {
  margin: 21px 0 0 8px;
  font-size: 16px;
  font-family: Helvetica;
  color: #8d919b;
  line-height: 24px;
}
.home_Partnership_background {
  background: #f6f7fa;
}
.home_Partnership {
  width: 1200px;
  margin: 0 auto;
}
.home_Partnership_imgs {
  display: flex;
  justify-content: space-between;
  padding-bottom: 80px;
}
.home_Partnership_imgs img {
  width: 220px;
  cursor: pointer;
  height: 80px;
}

@keyframes mymove {
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
}
@media (max-width: 767px) {
  .home_position {
    width: 6.8rem;
  }
  .home_box {
    width: 100%;
    padding: 0.54rem 0.32rem 0.43rem 0.32rem;
    border-radius: 0.1rem;
    background-size: 100% 107%;
  }
  .home_box_main2 img {
    width: 2.67rem;
    height: 2.36rem;
  }
  .home_box_main2 h2 {
    font-size: 0.2rem;
    line-height: 0.18rem;
    margin-bottom: 0.52rem;
    margin-top: 0.3rem;
  }
  .home_box_main2_button {
    width: 3.04rem;
    height: 0.6rem;
    box-shadow: 0px 0.06rem 0.08rem 0px rgba(5, 0, 105, 0.24);
    border-radius: 0.08rem;
    font-size: 0.2rem;
    line-height: 0.6rem;
  }
  .home_box_close {
    right: 0.17rem;
    top: 0.27rem;
    width: 0.3rem;
    height: 0.3rem;
  }
  .home_box_img {
    width: 2.25rem;
    height: 2.8rem;
    margin-bottom: -0.1rem;
  }
  .home_box_content {
    width: 3.64rem;
  }
  .home_box_content h1 {
    font-size: 0.28rem;
    letter-spacing: -0.0016rem;
    line-height: 0.32rem;
  }
  .home_box_content h2 {
    font-size: 0.16rem;
    line-height: 0.2rem;
    margin: 0.2rem auto 0.28rem;
  }
  .home_box_content_text {
    height: 0.5rem;
    border-radius: 0.08rem;
    font-size: 0.18rem;
  }
  .home_box_content_text:hover {
    border: 0.02rem solid rgba(255, 99, 0, 1);
  }
  .homex_box_content_showfalse {
    font-size: 0.14rem;
    margin-top: 0.05rem;
  }
  .home_box_content label {
    font-size: 0.14rem;
    line-height: 0.16rem;
    margin: 0.18rem auto 0.28rem;
  }
  .home_box_content_check {
    margin-right: 0.1rem;
    margin-top: 0;
  }
  .home_box_content_download {
    height: 0.6rem;
    box-shadow: 0px 0.06rem 0.08rem 0px rgba(5, 0, 105, 0.24);
    border-radius: 0.08rem;
    line-height: 0.6rem;
    font-size: 0.2rem;
  }
  .home_display {
    padding: 0.84rem 0 1.18rem 0;
  }
  .home_display_title {
    font-family: Helvetica-Bold;
    font-size: 0.48rem;
    color: #222536;
    letter-spacing: 0;
    line-height: 0.64rem;
    font-weight: 700;
    margin-bottom: 0.72rem;
    text-align: center;
  }
  .home_display_box {
    width: 100%;
    margin: auto;
  }
  .home_display_content {
    position: relative;
  }
  .home_display_content_item {
    width: 6rem;
    height: 6.8rem;
    background: #ffffff;
    box-shadow: 0 0.16rem 0.36rem 0 rgba(139, 145, 160, 0.1);
    border-radius: 0.16rem;
    transition: all 2s;
  }
  .home_display_content_item:first-child {
    margin-left: 0.48rem;
  }
  .home_display_content_item:last-child {
    margin-right: 0.48rem;
  }
  .home_display_content_item + .home_display_content_item {
    margin-left: 0.32rem;
  }

  .home_display_content_item img {
    width: 100%;
    border-radius: 0.16rem 0.16rem 0 0;
    height: 3.38rem;
  }
  .home_display_content_box {
    display: flex;
    overflow: auto;
    padding-bottom: 0.2rem;
    gap: 0;
  }
  .home_display_content_item_content {
    padding: 0.4rem 0.48rem 0.48rem 0.48rem;
    display: flex;
    flex-direction: column;
    height: 3.42rem;
    justify-content: space-between;
  }
  .home_display_content_item_content h3 {
    font-family: Helvetica-Bold;
    font-size: 0.44rem;
    color: #222536;
    letter-spacing: 0;
    font-weight: 700;
    display: flex;
    justify-content: flex-start;
  }
  .home_display_content_item_content div {
    width: 5.04rem;
    height: 0.96rem;
    background: #ffffff;
    border: 0.04rem solid #fb5421;
    border-radius: 0.08rem;
    font-family: Helvetica-Bold;
    font-size: 0.28rem;
    color: #fb5421;
    letter-spacing: 0;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .home_what_box {
    width: 100%;
    /* padding: .67rem .46rem .37rem; */
    padding: 0.7rem 0.48rem 0.42rem;
  }
  .home_title {
    padding: 0.67rem 0 0.68rem;
    font-size: 0.46rem;
    font-family: Helvetica-Bold, Helvetica;
    font-weight: bold;
    color: #222536;
    line-height: 0.46rem;
  }

  .home_what_line {
    flex-direction: column;
    height: auto;
    padding-bottom: 0.77rem;
  }
  .home_what_line_text {
    width: 100%;
    margin: 0 !important;
  }
  .home_what_line_text_symbol {
    margin: 0 0 0.31rem;
  }
  .home_what_line_text_title {
    height: 0.74rem;
    margin-bottom: 0.2rem;
    font-size: 0.3rem;
    font-family: Helvetica-Bold, Helvetica;
    font-weight: bold;
    color: #222536;
    line-height: 0.42rem;
  }
  .home_what_line_text_content {
    font-size: 0.24rem;
    font-family: Helvetica;
    color: #8d919b;
    line-height: 0.36rem;
    margin-bottom: 0.4rem;
  }
  .home_what_line_img {
    margin: 0 !important;
    width: 100%;
    padding: 0.275rem;
  }

  .home_what_line2 {
    flex-direction: column-reverse;
  }
  .home_what_bottom {
    padding: 0.43rem 0 0.8rem 0;
  }
  .home_what_bottom_title1 {
    font-size: 0.46rem;
    font-weight: bold;
    line-height: 0.58rem;
  }
  .home_what_bottom_title2 {
    font-size: 0.28rem;
    line-height: 0.26rem;
  }
  .home_what_bottom_platform {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 0.48rem 0 0 0;
  }
  .home_what_bottom_platform2 {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    padding: 0 0 0.32rem 0;
  }
  .home_what_bottom_img1 {
    width: 3.03rem;
    height: 1.53rem;
    border-radius: 0.08rem;
    text-align: center;
    line-height: 1.53rem;
    box-shadow: 0px 0.02rem 0.2rem 0px rgba(139, 145, 160, 0.15);
  }
  .home_what_bottom_img1_img1 {
    width: 1.7rem;
    height: 0.61rem;
  }
  .home_what_bottom_img1_img2 {
    width: 2.14rem;
    height: 0.48rem;
  }
  .home_what_bottom_img2 {
    width: 3.03rem;
    height: 1.53rem;
    border-radius: 0.08rem;
    text-align: center;
    line-height: 1.53rem;
    position: relative;
    margin-top: 0.2rem;
    box-shadow: 0px 0.02rem 0.2rem 0px rgba(139, 145, 160, 0.15);
  }
  .home_what_bottom_img2_img1 {
    width: 1.65rem;
    height: 0.56rem;
  }
  .home_what_bottom_img2_img2 {
    width: 2.07rem;
    height: 0.42rem;
  }

  .home_why {
    width: 100%;
    padding: 0.61rem 0.46rem 1.15rem;
  }
  .home_title {
    padding: 0;
    margin-bottom: 0.62rem;
    font-size: 0.46rem;
    font-family: Helvetica-Bold, Helvetica;
    font-weight: bold;
    color: #222536;
    line-height: 0.58rem;
  }
  .home_why_box {
    flex-direction: column;
  }
  .home_why_column {
    width: 100%;
  }
  .home_why_column > img {
    width: 100%;
    border-radius: 6px;
  }
  .home_why_column_title {
    margin: 0.39rem 0 0.17rem;
    font-size: 0.29rem;
    font-family: Helvetica-Bold, Helvetica;
    font-weight: bold;
    color: #222536;
    line-height: 0.4rem;
  }
  .home_why_column_content {
    font-size: 0.23rem;
    font-family: Helvetica;
    color: #8d919b;
    line-height: 0.35rem;
    padding: 0;
  }
  .home_why_column + .home_why_column {
    margin-top: 0.77rem;
  }
  .home_say {
    padding: 0.64rem 0.48rem 1.15rem;
  }
  .home_say_box {
    width: 100%;
  }
  .home_say_title {
    margin-bottom: 0.39rem;
    font-size: 0.48rem;
    font-family: Helvetica-Bold, Helvetica;
    font-weight: bold;
    color: #222536;
    line-height: 0.6rem;
    margin: 0 auto 0.39rem;
    padding: 0 0.1rem;
  }
  .home_say_content_line {
    overflow: auto;
  }
  .home_say_content_item {
    width: 5.75rem;
    height: 5.86rem;
    padding: 0.6rem 0.48rem 0.62rem;
  }
  .home_say_content_top img {
    width: 0.72rem;
    height: 0.72rem;
  }
  .home_say_content_top em {
    width: 0.02rem;
    height: 0.24rem;
    background: #8d919b;
  }
  .home_say_content_top_name {
    margin: 0 0.24rem 0 0.42rem;
    font-size: 0.3rem;
    font-family: Helvetica-Bold, Helvetica;
    font-weight: bold;
    color: #222536;
    line-height: 0.42rem;
  }
  .home_say_content_top_country {
    font-size: 0.24rem;
    font-family: Helvetica;
    color: #8d919b;
    line-height: 0.42rem;
    margin-left: 0.24rem;
  }
  .home_say_content_text {
    margin: 0.31rem 0 0;
    font-size: 0.24rem;
    font-family: Helvetica;
    color: #8d919b;
    line-height: 0.36rem;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 10;
    overflow: hidden;
  }
  .home_say_left,
  .home_say_right {
    display: none;
  }
  .home_Partnership {
    width: 100%;
    padding: 0.61rem 0.46rem 1.15rem;
  }
  /* .home_title{
    margin-bottom: .61rem;
    font-size: .46rem;
    font-family: Helvetica-Bold, Helvetica;
    font-weight: bold;
    color: #222536;
    line-height: .58rem;
  } */
  .home_Partnership_imgs {
    padding: 0;
  }
  .home_Partnership_imgs > img {
    width: 1.27rem;
    height: 0.46rem;
  }
}
</style>
<style>
.top_bg_h {
  width: 1243px;
  height: 583px;
  border-radius: 292px;
  opacity: 0.55;
  border: 120px solid #f6f7fa;
  position: absolute;
  top: 87px;
  left: 0;
}
.top_left_symbol_pro_h {
  margin: 63px 0 21px !important;
}
.top_left_content_pro_h {
  font-size: 16px;
  font-family: Helvetica;
  color: #8d919b;
  line-height: 21px;
  margin-bottom: 12px;
  color: #32404d;
  display: flex;
  align-items: flex-start;
}
.top_left_content_pro_h > em {
  margin-top: 4px;
}
.top_left_content_pro_h:last-child {
  margin-bottom: 26px;
}
@media (max-width: 767px) {
  .top_bg_h {
    display: none;
  }
  .top_left_content_pro_h > em {
    margin-top: 0.11rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue